import { Component, OnInit, Inject, ɵConsole, Input } from "@angular/core";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms";
import { MailService } from "src/app/services/mail/mail.service";
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Email } from "../../../interfaces/Email";
import { environment } from "src/environments/environment";
import { LoginService } from "../../../services/login/login.service";
import { FuncionesService } from "../../../services/funciones/funciones.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-modificaciones-dialog.component",
  templateUrl: "./modificaciones-dialog.component.html",
  styleUrls: ["./modificaciones-dialog.component.scss"],
})
export class ModificacionesComponent implements OnInit {
  // declarations
  //option:any;
  // @Input() CodigoContrato: any;
  form: FormGroup;
  texto: any;
  asunto: any;
  CodigoContrato: any;
  tokenvalidado: any;
  IsAdministrador: any;
  Email: any;
  selectedFiles: File[] = [];
  fileNames: string[] = [];
  puedeEnviar = false;
  adjuntar = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private _mailService: MailService,
    private _loginService: LoginService,
    private _funcionesService: FuncionesService,
    public dialogRef: MatDialogRef<ModificacionesComponent>,
  ) {
    this.dialogRef.updateSize("100%", "100%");
  }

  ngOnInit() {
    this.CodigoContrato = this.data.CodigoContrato;
    console.log(this.data);
    this.form = this.fb.group({
      texto: new FormControl(),
      option: new FormControl(),
    });
    if (this._loginService.datosTitular === undefined) {
      this._loginService
        .getvalidaToken(localStorage.getItem("idCliente"))
        .subscribe((data) => {
          this.tokenvalidado = this._funcionesService.decodificarToken(data);
          if (this.tokenvalidado.Valido == true) {
            this._loginService
              .getLogin(
                this._funcionesService.decodificarToken(
                  JSON.parse(localStorage.getItem("u")),
                ),
                this._funcionesService.decodificarToken(
                  JSON.parse(localStorage.getItem("p")),
                ),
              )
              .toPromise()
              .then(async (data) => {
                this._loginService.datosTitular =
                  this._funcionesService.decodificarToken(data);
                console.log(this._loginService.datosTitular);
                this.loadData();
              });
          } else {
            this.router.navigate(["/salir"]);
          }
        });
    } else {
      this.loadData();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  cambio(event: any) {
    console.log(event.value);
    this.adjuntar = true;
    var value = event.value;
    if (value == "resto") {
      this.downloadPDF(
        "documentosMod/SOLICITUD CAMBIO DATOS ADMINISTRATIVOS PLANTILLA.pdf",
        "SOLICITUD CAMBIO DATOS ADMINISTRATIVOS PLANTILLA.pdf",
      );
    } else if (value == "sepa") {
      this.downloadPDF(
        "documentosMod/SOLICITUD DE CAMBIO CUENTA BANCARIA PLANTILLA.pdf",
        "SOLICITUD DE CAMBIO CUENTA BANCARIA PLANTILLA.pdf",
      );
    } else if (value == "potencia") {
      this.downloadPDF(
        "documentosMod/SOLICITUD MODIFICACION DE POTENCIA TARIFA 2.0TD  ELEK COMERCIALIZADORA ELECTRICA SL.pdf",
        "SOLICITUD MODIFICACION DE POTENCIA TARIFA 2.0TD  ELEK COMERCIALIZADORA ELECTRICA SL.pdf",
      );
      this.downloadPDF(
        "documentosMod/SOLICITUD MODIFICACION DE POTENCIA TARIFA 3.0TD  ELEK COMERCIALIZADORA ELECTRICA SL.pdf",
        "SOLICITUD MODIFICACION DE POTENCIA TARIFA 3.0TD  ELEK COMERCIALIZADORA ELECTRICA SL.pdf",
      );
    } else if (value == "admin") {
      this.downloadPDF(
        "documentosMod/HOJA CAMBIO ADMINISTRADOR PLANTILLA.pdf",
        "HOJA CAMBIO ADMINISTRADOR PLANTILLA.pdf",
      );
    }
  }

  consultar() {
    let cuerpo = "";
    let replyTo = "";
    const valor = this.form.get("option")?.value;

    cuerpo =
      "<h3>El cliente con código de contrato " +
      this.CodigoContrato + ' y email : ' + this.Email +
      " adjunta la siguiente solicitud de modificación de sus datos :</h3>";
    this.asunto = "Solicitud cambio datos de cliente de la oficina virtual";

    if (this.form.value.texto) {
      cuerpo += "<p>" + this.form.value.texto + "</p>";
    }

    // 👉 Crear FormData
    const formData = new FormData();

    

    formData.append("Asunto", this.asunto);
    formData.append("Destinatario", environment.email);
    formData.append("Cuerpo", cuerpo);
    formData.append("ReplyTo", replyTo);

    // 👉 Añadir archivos adjuntos si existen
    if (this.selectedFiles.length > 0) {
        this.selectedFiles.forEach(file => {
        formData.append('adjunto[]', file);
      });
    }

    // 👉 Enviar
    this._mailService.getEnvioEmail(formData).subscribe((data) => {
      console.log(data);
    });

    this.dialogRef.close();
  }

  clickEleccion() {
    // this.dialogRef.close(this.eleccion);
  }

  loadData() {
    this.IsAdministrador = localStorage.getItem("isAdminFincas") === "true";
    if (this.IsAdministrador) {
      // this.NombreCliente = this._loginService.datosTitular.NombreCliente;
      // this.Apellido1Cliente = this._loginService.datosTitular.Apellido1Cliente;
      // this.Apellido2Cliente = this._loginService.datosTitular.Apellido2Cliente;
      // this.RazonSocialCliente = this._loginService.datosTitular.NombreAdministrador;
      // this.CiudadCliente = this._loginService.datosTitular.CiudadAdministrador;
      // this.CodigoPostalCliente = this._loginService.datosTitular.CodigoPostalAdministrador;
      // this.DireccionCliente = this._loginService.datosTitular.DireccionAdministrador;
      this.Email = this._loginService.datosTitular.EmailAdministrador;
    }
  }

  downloadPDF(url: string, nombreDocumento: string) {
    const link = document.createElement("a");
    link.href = url;
    link.download = nombreDocumento; // nombre del archivo
    link.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    this.selectedFiles = Array.from(input.files);
    this.fileNames = this.selectedFiles.map((file) => file.name);

    this.puedeEnviar = true;
  }
}
